module.exports = __webpack_public_path__ + "static/img/Tim-English.8439899.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tim-English.jpg
// module id = GxfI
// module chunks = 0